import React, { useState } from "react";
import {
  Box,
  Button,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../ppui";
import { TbPencil } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../style";
import useEpfService from "../statutory/epf/use-epf-service";
import { parseNumericValue } from "../../utils/common";
import { theme } from "../../theme";

const StatutoryEpfDetails = () => {
  // Modal
  const [openStatutoryEPFModal, setOpenStatutoryEPFModal] =
    React.useState(false);

  const [openEPFAddressModal, setOpenEPFAddressModal] = React.useState(false);

  const handleOpenStatutoryEPFModal = () => setOpenStatutoryEPFModal(true);
  const handleCloseStatutoryEPFModal = () => setOpenStatutoryEPFModal(false);

  const handleOpenEPFAddressModal = () => setOpenEPFAddressModal(true);
  const handleCloseEPFAddressModal = () => setOpenEPFAddressModal(false);
  // Modal

  const { handleClickOpen, handleClose, open, epfInputs } = useEpfService();

  const [employeeAssumeSalary, setEmployeeAssumeSalary] = useState(20000);
  let epsAmount = 0;
  let employeerContributionAmount = 15000;
  let employeeContributionAmount = 15000;
  const epfOrganizationStatus10Or12 = parseInt(
    epfInputs?.epfOrganizationStatus ? epfInputs?.epfOrganizationStatus : 12
  );

  if (
    epfInputs?.epfOrganizationEmployerContribution === "restrict_contribution"
  ) {
    epsAmount = (15000 * 8.33) / 100;
  } else {
    epsAmount =
      (employeeAssumeSalary * 8.33) / 100 > 1250
        ? 1250
        : (employeeAssumeSalary * 8.33) / 100;
  }

  if (
    epfInputs?.epfOrganizationEmployerContribution !== "restrict_contribution"
  ) {
    employeerContributionAmount = employeeAssumeSalary;
  }
  if (
    epfInputs?.epfOrganizationEmployeeContribution !== "restrict_contribution"
  ) {
    employeeContributionAmount = employeeAssumeSalary;
  }

  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          {`Employee's`} Under Provident Fund Details
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryEPFModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            EPF Number
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            HHHH78678678567
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            EPF Status
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Unexempted 12%
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Deduction Circle
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Monthly
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Place Of Posting Exemted
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Employee Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Restrict Contribution To ₹ 1500 Of PF Wages
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Employer Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Restrict Contribution To ₹ 1500 Of PF Wages
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Coverage Date
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            03-11-2024
          </Typography>
        </OrganizationBx>

        <Divider gap={20} />
      </OrganizationEmDetails>

      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          EPF Address Details
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenEPFAddressModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Under EPF Office
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Garia station road
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Address
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Saltlake Sector -V
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            City
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Kolkata
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            State
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Westbengal
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Country
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            India
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            PIN Code
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            236765
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Location
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Kolkata
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>
      <Divider gap={20} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Including {`employer's`} contribution in the CTC
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Include {`employer’s`} EDLI contribution in the CTC
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            No
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Include admin charges in the CTC
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Override PF contribution rate at employee level
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            No
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      <Gap height={20} />

      <Button
        disabled={epfInputs.epfOrganizationIsDisabled === true}
        color="primary"
        onClick={handleClickOpen}
        variant="outlined"
      >
        View Split up
      </Button>

      {/*View Split Modal */}
      <Dialog
        title="Sample EPF Calculation"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={() => alert("Submitted")}
        action={false}
      >
        <InputField
          variant="standard"
          type="number"
          onChange={(e) => setEmployeeAssumeSalary(e.target.value)}
          fullWidth
          label={`Let's assume the PF wage is`}
          suffix={"₹"}
          value={employeeAssumeSalary}
        />
        <Gap height={20} />

        <Box
          px={10}
          py={15}
          style={{ borderRadius: theme.radius.list }}
          bgColor={theme.colors.background.main}
          mb={15}
        >
          <Typography
            variant="body2"
            color="primary"
            colorVariant="light"
            fontWeight={500}
          >
            Contribution Rate :{" "}
            {epfOrganizationStatus10Or12 === 12
              ? "Unexempted 12%"
              : "Exempted 10%"}
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            colorVariant="light"
            fontWeight={500}
          >
            PF Contribution Settings
          </Typography>
          <Flex gap={10}>
            <Typography variant="body2" color="primary" colorVariant="light">
              Employee Contribution
            </Typography>
            <Typography variant="body2" color="primary" colorVariant="light">
              :
            </Typography>
            <Typography variant="body2" colorVariant="light">
              {" "}
              {epfInputs?.epfOrganizationEmployeeContribution ===
              "restrict_contribution"
                ? "Restrict"
                : "Unrestricted"}{" "}
              Contribution (Based on Actual Wages)
            </Typography>
          </Flex>
          <Flex gap={10} mb={10}>
            <Typography variant="body2" color="primary" colorVariant="light">
              Employer Contribution
            </Typography>
            <Typography variant="body2" color="primary" colorVariant="light">
              :
            </Typography>
            <Typography variant="body2" colorVariant="light">
              {epfInputs?.epfOrganizationEmployerContribution ===
              "restrict_contribution"
                ? "Restrict"
                : "Unrestricted"}{" "}
              Contribution (Based on Actual Wages)
            </Typography>
          </Flex>
        </Box>
        <Typography variant="body2" color="default" colorVariant="light">
          The breakup of contribution will be:
        </Typography>
        <Divider gap={15} />
        <Box>
          <Typography variant="body1" color="primary" fontWeight={500}>
            Employee{"'"}s Contribution
          </Typography>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" mb="0">
              EPF ({epfInputs?.epfOrganizationStatus} of{" "}
              {employeeContributionAmount})
            </Typography>
            <Typography variant="body2" mb="0">
              ₹{" "}
              {parseNumericValue(
                epfOrganizationStatus10Or12 * (employeeContributionAmount / 100)
              ).toFixed()}
            </Typography>
          </Flex>
          <Divider gap={15} />
          <Typography variant="body1" color="primary" fontWeight={500}>
            Employer{"'"}s Contribution
          </Typography>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2">
              EPS (8.33% of Wages (Maximum limit ₹1,250))
            </Typography>
            <Typography variant="body2">₹ {epsAmount.toFixed()}</Typography>
          </Flex>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" mb="0">
              EPF ({epfInputs?.epfOrganizationStatus} of{" "}
              {employeerContributionAmount} - EPS)
            </Typography>
            <Typography variant="body2" mb="0">
              ₹{" "}
              {parseNumericValue(
                (employeerContributionAmount * epfOrganizationStatus10Or12) /
                  100 -
                  epsAmount
              ).toFixed()}
            </Typography>
          </Flex>
          <Divider gap={15} />
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
              Total{" "}
            </Typography>
            <Typography variant="body2" color="primary" fontWeight={500} mb="0">
              ₹{" "}
              {parseNumericValue(
                epsAmount +
                  parseNumericValue(
                    (employeerContributionAmount *
                      epfOrganizationStatus10Or12) /
                      100
                  ) -
                  parseNumericValue(epsAmount)
              ).toFixed()}
            </Typography>
          </Flex>
          <Divider gap={15} />
        </Box>
      </Dialog>
      {/*View Split Modal */}

      {/* Statutory-EPF-Modal */}
      <Dialog
        title="Employee's Under Provident Fund Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openStatutoryEPFModal}
        onClose={handleCloseStatutoryEPFModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="EPF Number"
              placeholder="Type Here..."
              type="text"
            />
          </Col>
          <Col sm={6}>
            <SelectField
              fullWidth
              label="EPF Status"
              name="industry_type"
              options={[
                { id: "option1", name: "Unexempted 12%" },
                { id: "option2", name: "Exempted 10%" },
              ]}
              placeholder="Select Here..."
              required
            />
          </Col>
          <Col sm={6}>
            <InputField
              fullWidth
              label="Coverage Date"
              placeholder="Select Here..."
              type="date"
              valueSinc={true}
             
            />
          </Col>
          <Col sm={6}>
            <SelectField
              fullWidth
              label="Employee Contribution"
              name="Payment_Type"
              options={[
                {
                  id: "option1",
                  name: "Restrict Contribution To ₹1500 Of Wages",
                },
                {
                  id: "option2",
                  name: "Unrestricted Contribution (Based On Actual Wages",
                },
              ]}
              placeholder="Select Here..."
           
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="Employer Contribution"
              name="Payment_Type"
              options={[
                {
                  id: "option1",
                  name: "Restrict Contribution To ₹1500 Of PF Wages",
                },
                {
                  id: "option2",
                  name: "Unrestricted Contribution (Based On Actual Wages",
                },
              ]}
              placeholder="Select Here..."
              
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Modal */}

      {/* Statutory-EPF-Address */}
      <Dialog
        title="EPF Address Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openEPFAddressModal}
        onClose={handleCloseEPFAddressModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="Under EPF Office"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Address"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="City"
              placeholder="Type Here..."
              type="text"
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="State"
              options={[
                { id: "option1", name: "West Bengal" },
                { id: "option2", name: "Bihar" },
              ]}
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="city"
              options={[
                { id: "option1", name: "India" },
                { id: "option2", name: "China" },
              ]}
              disabled
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Pin Code"
              placeholder="Select Here..."
              type="number"
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Location"
              placeholder="Select Here..."
              type="number"
            />
          </Col>
        </Row>
      </Dialog>
      {/* Statutory-EPF-Address */}
    </>
  );
};

export default StatutoryEpfDetails;
